import { NavLink } from 'react-router-dom';

const links = [
  { to: '/trainer/dashboard', label: 'Dashboard', icon: '🏠' },
  { to: '/trainer/profile', label: 'My Profile', icon: '👤' },
  { to: '/trainer/documents', label: 'Documents', icon: '📄' },
  { to: '/trainer/courses', label: 'My Courses', icon: '📚' },
  { to: '/trainer/batches', label: 'Batches', icon: '📅' },
  { to: '/trainer/students', label: 'Students', icon: '🧑‍🎓' },
  { to: '/trainer/earnings', label: 'Earnings & Payouts', icon: '💸' },
  { to: '/trainer/reviews', label: 'Reviews', icon: '⭐' },
  { to: '/trainer/support', label: 'Support', icon: '💬' },
  { to: '/trainer/settings', label: 'Settings', icon: '⚙️' },
];

export const TrainerSidebar = () => (
  <aside className="hidden w-60 shrink-0 border-r border-slate-200 bg-white p-4 md:block">
    <p className="px-2 text-xs font-black uppercase tracking-wider text-slate-400">Trainer</p>
    <nav className="mt-2 flex flex-col gap-1">
      {links.map((l) => (
        <NavLink
          key={l.to}
          to={l.to}
          className={({ isActive }) =>
            `flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-bold transition ${
              isActive ? 'bg-[#000080] text-white' : 'text-slate-700 hover:bg-slate-100'
            }`
          }
        >
          <span aria-hidden>{l.icon}</span>
          <span>{l.label}</span>
        </NavLink>
      ))}
    </nav>
  </aside>
);
